var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: 'Copied!',
    trigger: 'manual',
    show: _vm.isOpenedTooltip,
  }),expression:"{\n    content: 'Copied!',\n    trigger: 'manual',\n    show: isOpenedTooltip,\n  }"}],staticClass:"v-copied-value",on:{"click":function($event){return _vm.copyValue(_vm.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }